import { useLogout, useIsAuthenticated } from '@ux/auth';
import { useMyAccount } from '@ux/accounts-client';
import { v4 } from 'is-uuid';
import { f as useLoginUrl, g as useRegisterUrl, h as useHelpUrl, i as useAccountUrl, j as useAccountLinks, k as useHasAccount, u as useBookends, l as useLogos, m as useHomeUrl, G as GlyphAlignment, H as HeaderColorways, n as getCurrencyPickerLinks, o as hasCurrencyPicker, p as getCurrentCurrency, q as useSetLanguage } from './index-905103ef.js';
import { useEffect, useRef, useState, forwardRef, cloneElement, useCallback } from 'react';
import { Message, getMessage, useMessage } from '@uds/message';
import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { useIntl } from 'react-intl';
import { useSupportedCurrencies, useCurrency, useSaveCurrency } from '@ux/currency';
import { getLocaleCode, getCountryCode, useLanguage } from '@ux/language';
import { SVGFlag } from '@uds/flag';
import './languagelabel.stylesheet_1bydy.css';
import { dispatchGAEvent } from '@uds/tagmg';
import { cssTheme } from '@uds/theme-utils';
import './picker.stylesheet_1sdqf0u.css';
import { cx } from 'linaria';
import './mastheadpopoutbutton.stylesheet_1ta9x9o.css';
import { Glyph } from '@uds/glyphs';
import { classNames } from '@uds/typography';
import './mastheadlink.stylesheet_1pwh77h.css';
import Colorway from '@uds/colorway';
import './popout.stylesheet_yym5ms.css';
import './popoutlink.stylesheet_1a3xsog.css';
import './userdetails.stylesheet_19hsuiq.css';
import Badge from '@uds/badge';
import './navlink.stylesheet_dtzwwk.css';

// Close dropdown when click outside
const useWithClickOutside = props => {
  const {
    ref,
    open,
    onClick
  } = props;
  useEffect(() => {
    const handleClick = event => {
      var _ref$current;
      if (onClick != null && open === true && event.target instanceof Node && !((_ref$current = ref.current) !== null && _ref$current !== void 0 && _ref$current.contains(event.target))) {
        onClick();
      }
    };
    document.addEventListener('click', handleClick, true);
    return () => document.removeEventListener('click', handleClick, true);
  }, [ref, open, onClick]);
  return {
    ...props,
    ref
  };
};
var useWithClickOutside$1 = useWithClickOutside;

const getUserDetails = account => {
  var _account$firstName, _account$lastName;
  return account != null ? {
    name: `${(_account$firstName = account.firstName) != null ? _account$firstName : ''} ${(_account$lastName = account.lastName) != null ? _account$lastName : ''}`.trim(),
    email: account.email,
    username: account.userName,
    usernameIsUuid: v4(account.userName)
  } : undefined;
};

const useAccountOptions = () => {
  const loginUrl = useLoginUrl();
  const registerUrl = useRegisterUrl();
  const helpUrl = useHelpUrl().toString();
  const accountUrl = useAccountUrl();
  const {
    data: account
  } = useMyAccount();
  const logout = useLogout();
  const logoutEvent = ev => {
    ev === null || ev === void 0 ? void 0 : ev.preventDefault();
    logout({
      path: '/'
    });
  };
  const linksLogged = [{
    key: 'bks-account-account',
    label: 'bks.account',
    href: accountUrl,
    icon: 'arrowRight'
  }, {
    key: 'bks-account-support',
    label: 'bks.help',
    href: helpUrl,
    icon: 'arrowRight'
  }, {
    key: 'bks-account-logout',
    label: 'bks.logout',
    onClick: logoutEvent
  }];
  const linksLogout = [{
    key: 'bks-account-login',
    label: 'bks.login',
    href: loginUrl,
    icon: 'arrowCircleIn'
  }, {
    key: 'bks-account-register',
    label: 'bks.register',
    href: registerUrl,
    icon: 'avatar'
  }];
  return {
    links: useAccountLinks(),
    linksLogged,
    linksLogout,
    loggedIn: useIsAuthenticated(),
    hasAccount: useHasAccount(),
    userDetails: account != null ? getUserDetails(account) : undefined
  };
};

const item = "iiu162e";
const flag = "f1sw5q88";
const classnames$2 = {
  item,
  flag
};

const LanguageLabel = _ref => {
  let {
    lang,
    cascade
  } = _ref;
  return /*#__PURE__*/jsxs("span", {
    className: classnames$2.item,
    children: [/*#__PURE__*/jsx("span", {
      className: classnames$2.flag,
      children: /*#__PURE__*/jsx(SVGFlag, {
        code: lang
      })
    }), /*#__PURE__*/jsx(Message, {
      cascade: cascade
    })]
  });
};
LanguageLabel.displayName = 'LanguageLabel';
var LanguageLabel$1 = LanguageLabel;

const getLanguagePickerLinks = _ref => {
  let {
    languageMap,
    intl
  } = _ref;
  return Object.keys(languageMap).map(lang => {
    const formatCountry = lang.replace('-', '.');
    const cascade = [{
      id: `country.language.iso2.${formatCountry}`
    }, {
      id: `country.language.iso2.${getLocaleCode(formatCountry)}`
    }, {
      id: `country.language.iso2.${getCountryCode(formatCountry)}`
    }];
    return {
      key: lang,
      href: languageMap[lang],
      option: intl ? getMessage(cascade, intl) : lang,
      label: /*#__PURE__*/jsx(LanguageLabel$1, {
        lang: lang,
        cascade: cascade
      })
    };
  });
};
const getCurrentLanguage = _ref2 => {
  var _links$find;
  let {
    links,
    currentLanguage
  } = _ref2;
  return (_links$find = links.find(link => link.key === currentLanguage)) != null ? _links$find : links[0];
};

const usePicker = _ref => {
  let {
    links,
    currentLink,
    onLinkClick,
    trackMenuOpen
  } = _ref;
  const ref = useRef(null);
  const getIndexLink = current => {
    const matched = links.findIndex(link => link.key === current.key && link.label === current.label && link.href === current.href);
    return matched === undefined ? -1 : matched;
  };
  const [opened, setOpened] = useState(false);
  const [selected, setSelected] = useState(currentLink);
  const [indexDropdown, setIndexDropdown] = useState(getIndexLink(currentLink));
  const [search, setSearch] = useState('');
  const [menuFocus, setMenuFocus] = useState(false);
  const [dropdownFocus, setDropdownFocus] = useState(false);
  const toggle = () => {
    setSearch('');
    setOpened(!opened);
  };
  const updateOptionSelected = index => {
    if (links.length > 0 && index >= 0 && index < links.length) {
      setIndexDropdown(index);
      setSelected(links[index]);
    }
  };
  useWithClickOutside$1({
    ref,
    open: opened,
    onClick: () => setOpened(false)
  });
  const onMenuClick = () => {
    if (!opened) {
      trackMenuOpen();
    }
    toggle();
  };
  const onItemClick = (link, e) => {
    e.preventDefault();
    updateOptionSelected(getIndexLink(link));
    onLinkClick(link);
    toggle();
  };
  const searchOption = keyPressed => {
    const string = `${search}${keyPressed}`;
    setSearch(string);
    const matched = links.find(link => {
      var _link$label$toString, _link$label;
      return new RegExp(`^${string}`, 'ig').test((_link$label$toString = (_link$label = link.label) === null || _link$label === void 0 ? void 0 : _link$label.toString()) != null ? _link$label$toString : '');
    });
    if (matched) {
      setSelected(matched);
    }
  };
  const onMenuKeyPress = e => {
    if (e.key === 'Enter') {
      onItemClick(links[indexDropdown], e);
    } else if (e.key === 'ArrowDown') {
      e.preventDefault();
      if (opened) {
        if (links.length > 0 && indexDropdown < links.length - 1) {
          updateOptionSelected(indexDropdown + 1);
        }
      } else {
        onMenuClick();
      }
    } else if (e.key === 'ArrowUp') {
      e.preventDefault();
      if (opened && indexDropdown >= 0) {
        if (indexDropdown > 0) {
          updateOptionSelected(indexDropdown - 1);
        } else {
          setOpened(false);
        }
      } else {
        onMenuClick();
      }
    } else if (e.key === 'Home') {
      e.preventDefault();
      if (opened) {
        updateOptionSelected(0);
      }
    } else if (e.key === 'End') {
      e.preventDefault();
      if (opened) {
        updateOptionSelected(links.length - 1);
      }
    } else if (e.key === 'Escape') {
      if (opened) {
        toggle();
      }
    } else if (e.key === 'Tab') {
      if (opened) {
        toggle();
        onLinkClick(links[indexDropdown]);
      }
    } else {
      searchOption(e.key);
    }
  };
  const onMenuFocus = () => {
    setMenuFocus(true);
    setSearch('');
  };
  const onMenuBlur = () => {
    setMenuFocus(false);
    if (opened && !dropdownFocus) {
      toggle();
    }
  };
  const onDropdownFocus = () => {
    setDropdownFocus(true);
  };
  const onDropdownBlur = () => {
    setDropdownFocus(false);
    if (opened && !menuFocus) {
      toggle();
    }
  };
  return {
    ref,
    opened,
    optionSelected: selected,
    onMenuClick,
    onItemClick,
    onMenuKeyPress,
    onMenuFocus,
    onMenuBlur,
    onDropdownFocus,
    onDropdownBlur
  };
};

const useToggleDropdown = function () {
  let initialOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const [isOpen, setIsOpen] = useState(initialOpen);
  const toggle = () => setIsOpen(open => !open);
  return {
    isOpen,
    toggle
  };
};

const Logo = _ref => {
  let {
    classname
  } = _ref;
  const {
    LinkComponent
  } = useBookends();
  const logo = useLogos();
  const homeUrl = useHomeUrl();
  return /*#__PURE__*/jsx("div", {
    className: classname,
    children: /*#__PURE__*/jsx(LinkComponent, {
      href: homeUrl,
      id: "bks-logo",
      children: /*#__PURE__*/jsx("img", {
        src: logo.logoContrast,
        alt: useMessage({
          id: 'bks.header.logo.alt'
        })
      })
    })
  });
};
Logo.displayName = 'Logo';
var Logo$1 = Logo;

const link$1 = {
  default: "ddcp995",
  noLink: "n5xxbnv"
};
const icon = "i1ef4w1n";
const iconColorway$1 = {
  LIGHT: cssTheme.palette.grey02,
  NEUTRAL: cssTheme.palette.grey02,
  DARK: '#fff',
  PRIMARY: cssTheme.palette.headerForeground,
  PRIMARY_GRADIENT: cssTheme.palette.headerForeground,
  HIGHLIGHT: cssTheme.palette.headerForeground,
  HEADER: cssTheme.palette.headerForeground
};
const withGlyph = {
  START: '',
  END: "e1yld6vp"
};
const getClassNames$4 = _ref => {
  let {
    noLink,
    glyphAlign,
    classname,
    classnameIcon,
    colorway
  } = _ref;
  return {
    link: cx(classNames.headingXxs, link$1.default, noLink && link$1.noLink, classname),
    glyph: cx(icon, classnameIcon, withGlyph[glyphAlign]),
    glyphStyle: {
      size: cssTheme.gu3,
      color: colorway ? iconColorway$1[colorway] : cssTheme.palette.primary
    }
  };
};

const MastheadLink = /*#__PURE__*/forwardRef((_ref, ref) => {
  var _glyph$color, _glyph$size;
  let {
    id,
    href,
    classname,
    glyph,
    glyphAlign = GlyphAlignment.START,
    label,
    values,
    onClick,
    onKeyPress,
    onFocus,
    onBlur,
    tabIndex,
    role,
    formatted
  } = _ref;
  const {
    LinkComponent,
    colorway
  } = useBookends();
  const classnames = getClassNames$4({
    noLink: (href == null || !href) && onClick == null,
    glyphAlign,
    classname,
    classnameIcon: glyph === null || glyph === void 0 ? void 0 : glyph.classname,
    colorway
  });
  return /*#__PURE__*/jsx("span", {
    ref: ref,
    children: /*#__PURE__*/jsxs(LinkComponent, {
      id: id,
      href: href,
      className: classnames.link,
      onMouseDown: onClick,
      onKeyDown: onKeyPress,
      onFocus: onFocus,
      onBlur: onBlur,
      tabIndex: tabIndex != null ? tabIndex : 0,
      role: role,
      children: [glyph != null && /*#__PURE__*/jsx("span", {
        className: classnames.glyph,
        children: /*#__PURE__*/jsx(Glyph, {
          name: glyph.icon,
          color: (_glyph$color = glyph.color) != null ? _glyph$color : classnames.glyphStyle.color,
          size: (_glyph$size = glyph.size) != null ? _glyph$size : classnames.glyphStyle.size
        })
      }), /*#__PURE__*/jsxs("div", {
        children: [/*#__PURE__*/jsx("div", {
          children: typeof label === 'string' ? /*#__PURE__*/jsx(Message, {
            id: label,
            values: values
          }) : label
        }), formatted !== null && formatted]
      })]
    })
  });
});
MastheadLink.displayName = 'MastheadLink';
var MastheadLink$1 = MastheadLink;

const root$4 = {
  default: "d5jcu74",
  flush: "f1eoi8a9"
};
const getClassNames$3 = _ref => {
  let {
    flush
  } = _ref;
  return {
    root: cx(root$4.default, flush && root$4.flush)
  };
};

const Popout = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    flush,
    id,
    label,
    onMouseOver,
    onFocus,
    onBlur
  } = _ref;
  const classNames = getClassNames$3({
    flush
  });
  const {
    colorwayAgainst
  } = useBookends();
  return /*#__PURE__*/jsx(Colorway, {
    colorway: colorwayAgainst,
    className: classNames.root,
    children: /*#__PURE__*/jsx("div", {
      ref: ref,
      id: id != null ? `${id}-options` : undefined,
      role: "listbox",
      "aria-label": label,
      onMouseOver: onMouseOver,
      onFocus: onFocus,
      onBlur: onBlur,
      children: children
    })
  });
});
Popout.displayName = 'Popout';
var Popout$1 = Popout;

const root$3 = "r1ydkbaq";
const getClassNames$2 = _ref => {
  let {
    className
  } = _ref;
  return {
    root: cx(classNames.headingXxs, root$3, className)
  };
};

const PopoutLink = _ref => {
  let {
    children,
    className,
    selected = false,
    ...props
  } = _ref;
  const classNames = getClassNames$2({
    className
  });
  return /*#__PURE__*/cloneElement(children, {
    ...props,
    'role': 'option',
    'aria-current': selected ? 'page' : undefined,
    'className': classNames.root
  });
};
PopoutLink.displayName = 'Popout';
var PopoutLink$1 = PopoutLink;

const root$2 = "r11nfrbk";
const backdropColorway = {
  LIGHT: "l3fu0it",
  NEUTRAL: "nrmm4wy",
  DARK: "dpeewbt",
  PRIMARY: "p1ko9p92",
  PRIMARY_GRADIENT: "plnwvqf",
  HIGHLIGHT: "h13gm9at",
  HEADER: "h1c9n6wn"
};
const backdrop = {
  default: "dqna9lx",
  opened: "o2o3t74"
};
const getClassNames$1 = _ref => {
  let {
    open,
    colorwayAgainst = HeaderColorways.DARK
  } = _ref;
  return {
    root: root$2,
    backdrop: cx(backdropColorway[colorwayAgainst], backdrop.default, open && backdrop.opened)
  };
};

const MastheadPopoutButton = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    onClick,
    onKeyPress,
    onFocus,
    onBlur,
    children,
    popoutOpened,
    showArrow = true,
    id
  } = _ref;
  const {
    colorwayAgainst
  } = useBookends();
  const classnames = getClassNames$1({
    open: popoutOpened === true,
    colorwayAgainst
  });
  return /*#__PURE__*/jsx("div", {
    className: classnames.root,
    children: /*#__PURE__*/jsx("span", {
      className: classnames.backdrop,
      children: /*#__PURE__*/jsx(MastheadLink$1, {
        ref: ref,
        id: id,
        label: children,
        glyph: showArrow ? {
          icon: 'chevronDown'
        } : undefined,
        glyphAlign: GlyphAlignment.END,
        onClick: onClick,
        onKeyPress: onKeyPress,
        onFocus: onFocus,
        onBlur: onBlur,
        role: 'button',
        "aria-haspopup": "listbox",
        "aria-controls": id != null ? `${id}-options` : undefined,
        "aria-expanded": popoutOpened
      })
    })
  });
});
MastheadPopoutButton.displayName = 'MastheadPopoutButton';
var MastheadPopoutButton$1 = MastheadPopoutButton;

const root$1 = "r1cdl99g";
const link = "l1ahr3rn";
const tick = "t1qfll43";
const iconColorway = {
  LIGHT: cssTheme.palette.primary,
  NEUTRAL: cssTheme.palette.primary,
  DARK: cssTheme.palette.primaryContrast,
  PRIMARY: cssTheme.palette.primaryContrast,
  PRIMARY_GRADIENT: cssTheme.palette.primaryContrast,
  HIGHLIGHT: cssTheme.palette.highlightContrast,
  HEADER: cssTheme.palette.headerForeground
};
const getClassNames = _ref => {
  let {
    colorwayAgainst = HeaderColorways.DARK
  } = _ref;
  return {
    classnames: {
      root: root$1,
      link,
      tick
    },
    tickStyle: {
      height: cssTheme.gu3,
      color: iconColorway[colorwayAgainst]
    }
  };
};

const Picker = _ref => {
  let {
    name,
    links,
    currentLink,
    onLinkClick = () => null
  } = _ref;
  const trackMenuOpen = useCallback(() => {
    dispatchGAEvent({
      hitType: 'event',
      eventCategory: 'Custom',
      eventAction: 'click',
      eventLabel: 'bks-language-menu-open'
    });
  }, []);
  const {
    ref,
    opened,
    optionSelected,
    onMenuClick,
    onItemClick,
    onMenuKeyPress,
    onMenuFocus,
    onMenuBlur,
    onDropdownFocus,
    onDropdownBlur
  } = usePicker({
    links,
    currentLink: currentLink != null ? currentLink : links[0],
    onLinkClick,
    trackMenuOpen
  });
  const {
    colorwayAgainst
  } = useBookends();
  const {
    classnames,
    tickStyle
  } = getClassNames({
    colorwayAgainst
  });
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: classnames.root,
    children: [/*#__PURE__*/jsx(MastheadPopoutButton$1, {
      onClick: onMenuClick,
      onKeyPress: e => onMenuKeyPress(e),
      onFocus: onMenuFocus,
      onBlur: onMenuBlur,
      popoutOpened: opened,
      children: optionSelected.label
    }), opened && /*#__PURE__*/jsx(Popout$1, {
      label: `Popout ${name}`,
      onMouseOver: onDropdownFocus,
      onFocus: onDropdownFocus,
      onBlur: onDropdownBlur,
      children: /*#__PURE__*/jsx(Fragment, {
        children: links.map(link => /*#__PURE__*/jsx(PopoutLink$1, {
          selected: link.key === optionSelected.key,
          children: /*#__PURE__*/jsx(MastheadLink$1, {
            href: link.href,
            onClick: e => onItemClick(link, e),
            label: link.label,
            classname: classnames.link,
            glyph: link.key === optionSelected.key ? {
              icon: 'tick',
              color: tickStyle.color,
              size: tickStyle.height
            } : undefined,
            glyphAlign: GlyphAlignment.END,
            tabIndex: -1,
            role: 'link'
          })
        }, link.key))
      })
    })]
  });
};
Picker.displayName = 'Picker';
var Picker$1 = Picker;

const CurrencyPicker = () => {
  const loggedIn = useIsAuthenticated();
  const {
    data: account,
    isSuccess
  } = useMyAccount();
  const currencies = useSupportedCurrencies();
  const currentCurrency = useCurrency();
  const saveCurrency = useSaveCurrency();
  const intl = useIntl();
  const links = getCurrencyPickerLinks({
    currencies,
    intl
  });
  const showPicker = hasCurrencyPicker({
    currencies,
    loggedIn,
    accountCurrency: account === null || account === void 0 ? void 0 : account.currency,
    accountFetched: isSuccess
  });
  const onClick = _ref => {
    let {
      key
    } = _ref;
    if (key != null) {
      saveCurrency(key.toString());
    }
  };
  return /*#__PURE__*/jsx(Fragment, {
    children: links.length > 1 && showPicker && /*#__PURE__*/jsx(Picker$1, {
      name: "currency",
      links: links,
      currentLink: getCurrentCurrency({
        links,
        currentCurrency
      }),
      onLinkClick: onClick
    })
  });
};
CurrencyPicker.displayName = 'CurrencyPicker';
var CurrencyPicker$1 = CurrencyPicker;

const LanguagePicker = () => {
  const intl = useIntl();
  const {
    languageMap,
    onLanguageChange
  } = useBookends();
  const {
    data: currentLanguage
  } = useLanguage();
  const setLanguage = useSetLanguage();
  const links = languageMap != null ? getLanguagePickerLinks({
    languageMap,
    intl
  }) : [];
  const currentLink = links.length > 0 ? getCurrentLanguage({
    links,
    currentLanguage: currentLanguage != null ? currentLanguage : 'en-gb'
  }) : undefined;
  const onClick = link => {
    if (onLanguageChange != null && link.href != null) {
      var _link$key;
      onLanguageChange(link.href, (_link$key = link.key) === null || _link$key === void 0 ? void 0 : _link$key.toString());
    }
    setLanguage(link);
  };
  return /*#__PURE__*/jsx(Fragment, {
    children: links.length > 1 && /*#__PURE__*/jsx(Picker$1, {
      name: "language",
      links: links,
      currentLink: currentLink,
      onLinkClick: onClick
    })
  });
};
LanguagePicker.displayName = 'LanguagePicker';
var LanguagePicker$1 = LanguagePicker;

const root = "r38e10k";
// The avatar 👇 and border color 👆 doesn't seem to align with the
// Rest of the usage when the colorway is header.
// I'll rather add an override for this particular
// Colorway, rather than trying to make a new variable at this point
const avatar = "aq510zv";
const name = "ntjzde9";
const email = "eee7mtv";
const username = "ugb6fh4";
const classnames$1 = {
  root: cx(classNames.content, root),
  avatar: cx(classNames.headingL, avatar),
  name: cx(classNames.headingM, name),
  email,
  username
};

const UserDetails = _ref => {
  let {
    name,
    email,
    username,
    usernameIsUuid = false
  } = _ref;
  const {
    colorway
  } = useBookends();
  const colorwayClassName = (colorway != null ? colorway : '').toLowerCase();
  return /*#__PURE__*/jsxs("aside", {
    className: cx(classnames$1.root, colorwayClassName),
    children: [name.length > 0 && /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx("div", {
        className: cx(classnames$1.avatar, colorwayClassName),
        children: name.charAt(0)
      }), /*#__PURE__*/jsx("div", {
        className: classnames$1.name,
        children: name
      })]
    }), /*#__PURE__*/jsx("div", {
      className: classnames$1.email,
      children: email
    }), usernameIsUuid === false && /*#__PURE__*/jsx("div", {
      className: classnames$1.username,
      children: username
    })]
  });
};
UserDetails.displayName = 'UserDetails';
var UserDetails$1 = UserDetails;

const badge = "b1g4uexy";
const classnames = {
  promo: classNames.smallprint,
  badge
};

const NavLink = _ref => {
  let {
    label,
    promo,
    promoLabel
  } = _ref;
  return /*#__PURE__*/jsxs(Fragment, {
    children: [typeof label === 'string' ? /*#__PURE__*/jsx(Message, {
      id: label
    }) : label, promo && promoLabel != null && /*#__PURE__*/jsx("span", {
      className: classnames.badge,
      children: /*#__PURE__*/jsx(Badge, {
        children: /*#__PURE__*/jsx("span", {
          className: classnames.promo,
          children: /*#__PURE__*/jsx(Message, {
            id: promoLabel
          })
        })
      })
    })]
  });
};
NavLink.displayName = 'NavLink';
var NavLink$1 = NavLink;

export { CurrencyPicker$1 as C, Logo$1 as L, MastheadPopoutButton$1 as M, NavLink$1 as N, Popout$1 as P, UserDetails$1 as U, useToggleDropdown as a, PopoutLink$1 as b, MastheadLink$1 as c, useAccountOptions as d, LanguagePicker$1 as e, useWithClickOutside$1 as u };
